import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=567dac37&scoped=true&"
import script from "./Categories.vue?vue&type=script&lang=js&"
export * from "./Categories.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Categories.vue?vue&type=style&index=0&id=567dac37&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "567dac37",
  "4d203a67"
  
)

export default component.exports